import { getBlocks, isBlocked } from '@tymbe/utils/company-blocked-user';
import { GroupBase } from 'react-select';
import { SelectComponents } from 'react-select/dist/declarations/src/components';

import { InvitationSelectContainer, InvitationSelectControl, InvitationSelectInput, InvitationSelectMenu, InvitationSelectMenuList, InvitationSelectMultiValue, InvitationSelectNoOptionsMessage, InvitationSelectOption } from './TySelectInvitationCustomComponents';
import { OwnProps, TySelectInvitationOptionData, TySelectInvitationQueryConfig } from './TySelectInvitationTypes';
import { loadPersonOptions, renderOptionLabel } from './TySelectInvitationUtils';
import TyAsyncSelect, { TyAsyncSelectProps } from '../../../../../components/inputs/TyAsyncSelect';
import { PersonData } from '@tymbe/schema/person.interface';
import { InputWrapper } from 'libs/ui/forms/src/common';
import TyAsyncSelectInvitations from 'apps/admin/src/pages/shift/create/components/TySelectInvitations/TyAsyncSelectInvitations';

const invitationCustomSelectComponents: Partial<SelectComponents<PersonData, boolean, GroupBase<PersonData>>> = {
  MultiValue: InvitationSelectMultiValue,
  Menu: InvitationSelectMenu,
  Option: InvitationSelectOption,
  Input: InvitationSelectInput,
  SelectContainer: InvitationSelectContainer,
  Control: InvitationSelectControl,
  NoOptionsMessage: InvitationSelectNoOptionsMessage,
  MenuList: InvitationSelectMenuList,
  DropdownIndicator: () => null,
  IndicatorSeparator: () => null,
};

const TySelectInvitations = <Fields extends object>(props: Omit<TyAsyncSelectProps<
Fields,
PersonData,
GroupBase<PersonData>,
void,
boolean
> &
OwnProps, 'loadOptions'>) => {
  const queryConfig: TySelectInvitationQueryConfig = {
    companyId: { ...props }.companyId,
    branchOfficeId: { ...props }.branchOfficeId,
    onlyInvitable: { ...props }.onlyInvitable,
    filter: { ...props }.filter,
    exclude: { ...props }.exclude,
    limitToRelatedCompanies: { ...props }.limitToRelatedCompanies,
    shiftPerks: { ...props }.shiftPerks,
  };

  return (
    <TyAsyncSelectInvitations
        key={`${props?.companyId}-${props?.branchOfficeId}-${props?.departmentId}-${props?.shiftPerks}`}
        {...props}
        debounceTimeout={1000}
        loadOptions={loadPersonOptions(queryConfig)}
        getOptionLabel={(option: TySelectInvitationOptionData) =>
          renderOptionLabel(option, {
            id: props?.companyId,
            branchoffice: props?.branchOfficeId,
            department: props?.departmentId,
          })}
        isOptionDisabled={(option) => isBlocked(getBlocks(option.blockedCompany, {
          id: props?.companyId,
          branchoffice: props?.branchOfficeId,
          department: props?.departmentId,
        }))}
        defaultMenuIsOpen={props.defaultMenuIsOpen ? props.defaultMenuIsOpen : !!props?.departmentId}
        customSelectComponents={invitationCustomSelectComponents}
        getOptionValue={(option) => String(option.id)}
      />
  );
};

export default TySelectInvitations;
